import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-selected-icon',
  templateUrl: './selected-icon.component.html',
  styleUrls: ['./selected-icon.component.scss'],
})
export class SelectedIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
